import axios from "axios";
import { getServerURL } from "./config";

const clienteAxios = axios.create({
    baseURL: getServerURL(),
    timeout: 360000,
    headers: {
        'Content-Type': 'application/json'
    }
});

clienteAxios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) config.headers['Authorization'] = `Bearer ${token}`
        return config;
    },
    (error) => {
        console.log("error sending token in the request");
        console.log(error);
        return Promise.reject(error);
    }
)

export default clienteAxios;
